import { entityActionWrapper } from 'barnyard/utils';
import * as types from '../constants';


const buyerWithMetadata = entityActionWrapper({
  UPDATE_ACTION: types.BUYER_UPDATE
});

const buyer = (state = {}, action) => {
  switch (action.type) {
    case types.BUYER_UPDATE.request:
    case types.BUYER_UPDATE.success:
    case types.BUYER_UPDATE.failure:
      return buyerWithMetadata(state, action, action.result);
    case types.PROFILE_FETCH.success:
      return action.buyer;
    default:
      return state;
  }
};

export {
  buyer,
};
